import * as _ from "lodash";
import * as log from "loglevel";
import * as React from "react";

import { observable } from "mobx";
import { inject, observer, Provider } from "mobx-react";
import { Link } from "react-router-dom";
import { Button, Checkbox, Dropdown, Icon, List, Loader, SemanticICONS } from "semantic-ui-react";
import { DialogService } from "../../services/dialog-service";
import { AppStore } from "../../stores/app-store";
import { AuthStore } from "../../stores/auth-store";
import { App } from "../../stores/models/app";
import { Project } from "../../stores/models/project";
import { ProjectApp } from "../../stores/models/project-app";
import { User } from "../../stores/models/user";
import { ProjectAppStore } from "../../stores/project-app-store";
import { ProjectStore } from "../../stores/project-store";
import { UserStore } from "../../stores/user-store";
import { EditorPane } from "../common/editor-pane";

declare var toastr: any;

interface IProjectAppControlProps{
	appStore?: AppStore;
	projectAppStore?: ProjectAppStore;
	project?: Project;
	show?: boolean;
	onClose?(): void;
}

interface IProjectAppControlState{
	errorMessage?: string;
}

@inject("appStore", "projectAppStore") @observer
export class ProjectAppControl extends React.Component<IProjectAppControlProps, IProjectAppControlState>{
	constructor(props, state){
		super(props, state);
		this.state = {"errorMessage": null};
		this.handleProjectAppChange = this.handleProjectAppChange.bind(this);
		this.handleClose = this.handleClose.bind(this);
	}

	async componentDidMount(){
		if(this.props.show){
			await this.load(this.props);
		}
	}

	async componentWillReceiveProps(nextProps: IProjectAppControlProps){
		if(nextProps && nextProps.show){
			await this.load(nextProps);
		}
	}

	async load(props: IProjectAppControlProps){
		if(props && props.project){
			log.debug("load - Project App Control");
			await Promise.all([props.appStore.loadApps(), props.projectAppStore.loadProjectApps(props.project.id)]);
		}
	}

	async handleProjectAppChange(appView: ProjectAppView){
		try{
			if(appView.active){
				await this.props.projectAppStore.remove(appView.projectApp);
			}
			else{
				let pa = new ProjectApp({"appId": appView.appId, "projectId": appView.projectId});
				await this.props.projectAppStore.create(pa);
			}
			toastr.success("Change Saved");
			await this.load(this.props);
			this.setState({"errorMessage": null});
		}
		catch(err){
			this.setState({"errorMessage": err.message});
		}
	}

	handleClose(){
		if(this.props.onClose){
			this.props.onClose();
		}
	}


	render(){
		const { appStore, projectAppStore, project } = this.props;

		let apps = [];
		if(project){
			apps = appStore.apps.filter(app => !app.internal).slice().map((app: App) => {
				let pa = _.find(projectAppStore.projectApps, {"appId": app.id});
				let appView = new ProjectAppView(app, project, pa);
				return appView;
			});
		}

		return (
			<div>
				<EditorPane title={this.props.project ? `${this.props.project.surveyId} Application Controls` : `Application Controls`} show={this.props.show} onClose={this.handleClose} width={500}>
					{project && <List relaxed>
						{apps.map((app: ProjectAppView) => {
							return(
							<List.Item icon={<Icon name={app.icon as SemanticICONS} size="large" style={{"width" : "30px"}} />} content=
								{
									<div>
										<Button size="tiny" compact key={app.id}  active={app.active} toggle onClick={() => this.handleProjectAppChange(app)}>{app.name}</Button>
										&nbsp;&nbsp;&nbsp;{app.settingsUrl && <a href={`${app.settingsUrl}`} target="_blank"  ><Icon name="setting" size="large" /></a>}
									</div>
								} key={app.id}
								/>
							);
						})}
					</List>}
					<br /><br />
					<button className="ui primary button" onClick={this.handleClose}>
						Close
					</button>
					{projectAppStore.loading && <Loader active />}
					{this.state.errorMessage &&
						<div className="ui red icon message">
							<i className="warning sign icon"></i>
							{this.state.errorMessage}
						</div>
					}
				</EditorPane>
			</div>
		);
	}
}

class ProjectAppView{
	id: string;
	active: boolean = false;
	projectId: string;
	appId: string;
	icon: string;
	name: string;
	settingsUrl: string = null;
	projectAppId: string = null;
	projectApp: ProjectApp = null;

	constructor(app: App, project: Project, pa: ProjectApp){
		this.projectId = project.id;
		this.appId = app.id;
		this.icon = app.icon;
		this.name = app.name;
		this.id = `${this.projectId}-${this.appId}`;

		if(pa){
			this.active = true;
			this.settingsUrl = pa.settingsUrl;
			this.projectAppId = pa.id;
			this.projectApp = pa;
		}
	}
}



// WEBPACK FOOTER //
// ./src/views/projects/project-app-control.tsx